<template>
  <!-- LINK VERSION -->
  <a
    v-if="link"
    class="button"
    :href="link"
    target="_blank"
    rel="noopener noreferrer"
  >
    {{ label }}
  </a>

  <!-- BUTTON VERSION -->
  <button v-else class="button">
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "ButtonComponent",
  props: {
    label: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.button {
  background-color: transparent;
  color: var(--main-orange);
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  width: 208px;
  border: 2px solid var(--main-orange);
  font-size: 1.5rem;
  cursor: pointer;
  font-family: "Frank Ruhl Libre", serif;
  transition: all 0.2s ease;
  border-radius: 10px;
  text-decoration: none;
  margin-left: 0.5em;
  margin-right: 0.5em;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.button:hover {
  background-color: var(--main-orange);
  color: white;
  transform: scale(1.05);
}
</style>
